<template>
  <div class="massaction-confirm-modal">
    <div class="confirm-modal-title">
      {{ isSubmitted ? $t('addLabel.labelsAdded') : $t('addLabel.addLabel') }}
    </div>
    <template v-if="!isSubmitted">
      <div class="confirm-modal-body" v-html="$t('addLabel.addLabelConfirm')" />

      <div class="label-tag d-flex">
        <span v-if="labelArr && labelArr.length > 0" class="selections-label"
          >{{ $t('common.label')}}</span
        >
        <multiselect
          id="rfid-tag"
          class="label-tag-list"
          v-model="labelArr"
          :options="allLabelsArr"
          :placeholder="!labelArr || labelArr.length == 0 ? $t('common.label') : ''"
          :show-labels="false"
          :taggable="true"
          @tag="addLabelTag"
          multiple
          :allowEmpty="true"
          :showNoResults="true"
          :tagPlaceholder="$t('common.tagPlaceholder')"
          >
          <span slot="noResult">{{ $t('common.noOptionAvailable') }}</span>
        </multiselect>
      </div>
    </template>

    <template v-else>
      <div class="confirm-modal-body" v-html="$t('addLabel.labelsAddedTousers')"/>
    </template>

    <hr class="confirm-modal-divider" />
    <div class="d-flex justify-content-between w-60 m-auto">
      <button
        v-if="!isSubmitted"
        @click="addLabels"
        class="confirm-modal-btn"
        :disabled="!labelArr.length || isLoading"
      >
        <i
          v-if="isLoading"
          class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
        ></i>
        {{ $t('common.add') }}
      </button>
      <button
        v-if="!isSubmitted"
        @click="$bvModal.hide('add-label')"
        class="cancel-modal-btn"
      >
        {{ $t('common.cancel') }}
      </button>

      <button
        v-if="isSubmitted"
        @click="closeModal()"
        class="confirm-modal-btn"
        style="margin-inline-start: 25%"
      >
        {{ $t('common.okay') }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      labelArr: [],
      allLabelsArr: [],
      isLoading: false,
      isSubmitted: false,
    };
  },
  props: ["allLabels"],
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("authfack", ["currentEntity"]),
  },
  async mounted() {
    console.log("ffff", this.getModalInfo);
    this.allLabelsArr = this.allLabels.map((item) => {
      return item.name;
    });
  },
  methods: {
    ...mapActions("users", ["addLabel", "addLabelsMultiple"]),
    addLabelTag(newTag) {
      const labelExist = this.labelArr.find((label) => label == newTag);
      if (!labelExist) {
        this.labelArr.push(newTag);
      }
    },
    async addLabels() {
      this.isLoading = true;
      let formData = new FormData();
      formData.append("entityId", this.currentEntity.id);
      for (let i = 0; i < this.getModalInfo.length; i++) {
        formData.append("userIds[]", this.getModalInfo[i]);
      }
      console.log("1");
      const promises = [];
      for (let i = 0; i < this.labelArr.length; i++) {
        const labelExist = this.allLabels.find(
          (item) => item.name == this.labelArr[i]
        );
        if (!labelExist) {
          const addLabelPromise = this.addLabel({
            entity_id: this.currentEntity.id,
            name: this.labelArr[i],
          }).then((res) => {
            formData.append("labelIds[]", res.data.id);
          });
          promises.push(addLabelPromise);
        } else {
          formData.append("labelIds[]", labelExist.id);
        }
      }
      console.log("2");

      // Wait for all promises to complete before proceeding
      await Promise.all(promises);
      this.addLabelsMultiple(formData).then(() => {
        this.isSubmitted = true;
        this.isLoading = false;
      });
    },

    closeModal() {
      this.$emit("changeUserStatusOrDeleted");
      this.$bvModal.hide("add-label");
    },
  },
};
</script>

<style lang="scss">
.massaction-confirm-modal {
  .confirm-modal-title {
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: start;
  }

  .confirm-modal-body {
    color: #787878;

    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: center;
    margin: 40px 0;
  }

  .confirm-modal-btn {
    background-color: #103f5e;
    color: #ffffff;

    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0em;
    border: 0;
    border-radius: 24px;
    width: 112px;
    height: 33px;
  }

  .confirm-modal-divider {
    // margin: 0;
    margin-bottom: 20px;
  }

  .cancel-modal-btn {
    background-color: #ffffff;
    color: #f46a6a;
    border: 1px solid #f46a6a !important;
    width: 112px;
    height: 33px;
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0em;
    border: 0;
    border-radius: 24px;
  }

  .w-60 {
    width: 60%;
  }

  .rfid-tag,
  .label-tag {
    .multiselect {
      z-index: 10;

      .multiselect__input {
        background: #f2f2f2 !important;
      }

      .multiselect__placeholder {
        font-weight: 400 !important;
        font-size: 16px;
        line-height: 17px;
        padding-inline-start: 10px;

        letter-spacing: 0.25px;

        color: rgba(96, 96, 96, 0.87) !important;

        opacity: 0.8;
      }

      .multiselect__tag {
        font-size: 16px !important;
        line-height: 17px !important;
        font-weight: 700 !important;
        letter-spacing: 0.25px !important;
        padding-top: 10px !important;
        padding-inline-end: 48px !important;
        padding-bottom: 12px !important;
        padding-inline-start: 20px !important;
        border-radius: 6px !important;
        max-width: 376px;

        &:first-child {
          margin-top: 25px;
        }

        .multiselect__tag-icon:after {
          font-size: 22px;
        }

        i.multiselect__tag-icon {
          width: 32px;
          font-size: 22px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        i.multiselect__tag-icon:hover {
          background: #f46a6a;
        }
      }
    }
  }

  .rfid-tag,
  .rfid-tags {
    position: relative;
  }

  .rfid-tag .multiselect__content-wrapper {
    display: none;
  }

  .rfid-tag,
  .label-tag {
    .multiselect__tags {
      min-height: 55px !important;
      display: grid !important;
    }

    .multiselect__select {
      display: none;
    }
  }

  .multiselect__content-wrapper::-webkit-scrollbar {
    width: 9px;
    height: 30px !important;
  }

  .multiselect__content-wrapper::-webkit-scrollbar-track {
    background: #c7c7c7;
    padding-top: 30px !important;
    border-radius: 8.5px;
    -webkit-box-shadow: #ffff;
    margin-top: 21px !important;
    margin-bottom: 13px !important;
  }

  .multiselect__content-wrapper::-webkit-scrollbar-thumb {
    background: #666666;
    border-radius: 8.5px;
  }

  .multiselect {
    width: 416px;
    border-radius: 4px !important;

    .multiselect__select {
      top: 7px !important;
    }

    .multiselect__select:before {
      z-index: 2;
    }

    .multiselect__tags {
      min-height: 55px !important;
      background: #f2f2f2 !important;
      border-radius: 4px !important;
      border: none !important;
      display: flex;
      align-items: center;

      .multiselect__single {
        background: #f2f2f2 !important;

        font-weight: 700 !important;
        font-size: 16px !important;
        line-height: 17px !important;
        margin-inline-start: 7px;
        letter-spacing: 0.25px !important;
        padding-top: 15px;
        color: rgba(0, 0, 0, 0.87) !important;
        opacity: 0.8 !important;
      }

      .multiselect__placeholder {
        font-weight: 700;
        font-size: 16px;
        line-height: 17px;
        padding-inline-start: 10px;

        letter-spacing: 0.25px;

        color: rgba(96, 96, 96, 0.87) !important;

        opacity: 0.8;
      }
    }
  }

  .selections-label {
    position: absolute;
    color: #103f5e;
    margin-top: 10px;
    margin-inline-end: 0;
    margin-bottom: 0;
    margin-inline-start: 20px;
    z-index: 1000;

    font-size: 12px;
    font-weight: 700;
    line-height: 17px;
    letter-spacing: 0.25px;
    text-align: start;
  }

  button.confirm-modal-btn:disabled {
    opacity: 0.4;
  }
}
div#add-label___BV_modal_content_ {
  width: 579px !important;
  margin-top: 150px;
  border-radius: 26px !important;
  .confirm-modal-body {
    width: 416px;
    margin: 40px auto 16px auto;
  }
  .multiselect {
    margin: auto;
  }
  .label-tag-list {
    .multiselect__content-wrapper::-webkit-scrollbar {
      width: 9px;
      height: 10px !important;
    }
    .multiselect__content-wrapper::-webkit-scrollbar-track {
      background: #c7c7c7;
      padding-top: 30px !important;
      border-radius: 8.5px;
      -webkit-box-shadow: #ffff;
      margin-top: 21px !important;
      margin-bottom: 13px !important;
    }
    .multiselect__content-wrapper::-webkit-scrollbar-thumb {
      background: #666666;
      border-radius: 8.5px;
    }
  }
  .selections-label {
    margin-top: 10px;
    margin-inline-end: 0;
    margin-bottom: 0;
    margin-inline-start: 50px;
  }
  .confirm-modal-divider {
    margin-top: 40px;
  }
}
#add-label___BV_modal_outer_ {
  z-index: 9999999999 !important;
}
</style>
